<template>
  <v-dialog persistent v-model="showCompanyEditDialog" max-width="1080">
    <v-card>
      <v-card-title class="headline">Unternehmen bearbeiten</v-card-title>
      <v-card-subtitle style="margin:25px">
        Die Informationen werden zum Anlegen eines Verzeichnis nach Artikel 30 DSGVO benötigt.
      </v-card-subtitle>
      <v-card-text>
        <div style="margin:50px"></div>
        <div v-if="loading">Lade...</div>
        <div v-else-if="errors.length > 0">Fehler beim Laden</div>
        <div v-else-if="company" style="margin:25px">
          <v-text-field
            filled
            v-model="company.name"
            :counter="140"
            :rules="shortNameRules"
            label="Kurzname"
            placeholder="Kurzname für das Unternehmen"
            required
          >
          </v-text-field>
          <v-text-field
            v-model="company.fullname"
            :counter="140"
            :rules="nameRules"
            label="Voller Name"
            placeholder="Voller Unternehmensname"
          >
          </v-text-field>
          <v-text-field v-model="company.address_street" label="Straße"></v-text-field>
          <v-text-field v-model="company.address_street_no" label="Hausnummer"></v-text-field>
          <v-text-field v-model="company.address_zip" label="PLZ"></v-text-field>
          <v-text-field v-model="company.address_city" label="Stadt"></v-text-field>
          <v-text-field v-model="company.address_country" label="Land"></v-text-field>
          <v-text-field v-model="company.responsible_name" label="Verantwortlicher" placeholder="Max Mustermann">
          </v-text-field>
          <v-text-field
            v-model="company.responsible_role"
            label="Titel"
            placeholder="Geschäftsführer"
            @keyup.enter="saveChanges"
          >
          </v-text-field>
          <div v-if="company.createdAt">
            Erstellt: {{ company.createdAt | moment("DD.MM.YYYY") }} um {{ company.createdAt | moment("HH.mm") }} Uhr
          </div>
          <div v-if="company.updatedAt">
            Geändert: {{ company.updatedAt | moment("DD.MM.YYYY") }} um {{ company.updatedAt | moment("HH.mm") }} Uhr
          </div>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey darken-1" text @click="discard()">
          Abbrechen
        </v-btn>
        <v-btn class="v-accent v-raised" color="primary" outlined @click="saveChanges" :disabled="!company.name">
          Speichern
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
const getCompany = `query GetCompany($id: ID!) {
  getCompany(id: $id) {
    id
    name
    fullname
    address_street
    address_street_no
    address_zip
    address_city
    address_country
    responsible_name
    responsible_role
    processes (limit: 500){
        items{
            id
        }
    }
    createdAt
    updatedAt
    archived_at
    deleted_at
  }
}
`;
const updateCompany = `mutation UpdateCompany($input: UpdateCompanyInput!) {
  updateCompany(input: $input) {
    id
    name
    fullname
    address_street
    address_street_no
    address_zip
    address_city
    address_country
    responsible_name
    responsible_role
    processes (limit: 500){
        items{
            id
        }
    }
    createdAt
    updatedAt
    archived_at
    deleted_at
  }
}
`;

const plans_specs = require("json-loader!yaml-loader!../specs/plans.yml");
function arrayToObject(arr, key) {
  var rv = {};
  for (var i = 0; i < arr.length; ++i) rv[arr[i][key]] = arr[i];
  return rv;
}
const products = arrayToObject(plans_specs.products, "id");

export default {
  name: "CompanyEditView",
  props: {
    company_id: String,
    showThis: Boolean,
  },
  watch: {
    showThis(st) {
      this.showCompanyEditDialog = st;
      if (st) {
        this.init();
      }
    },
    showCompanyEditDialog: function(show) {
      if (show === false) {
        this.$emit("discard");
      }
    },
  },
  computed: {
    getCompanyQuery() {
      return this.$Amplify.graphqlOperation(getCompany, { id: this.company.id });
    },
    updateCompanyMutation() {
      return this.$Amplify.graphqlOperation(updateCompany, { input: this.company_for_save });
    },
    user_info() {
      return this.$store.state.originalStore.user_info;
    },
    did_change: {
      get() {
        return this.$data._did_change;
      },
      set(value) {
        if (value === true && this.$data.company.name !== "") {
          this.$eventHub.emit("sync-status-touched");
          clearTimeout(this.$data._save_timer);
          this.$data._save_timer = setTimeout(() => this.save(), 2000);
        }
        this.$data._did_change = value;
      },
    },
    company_for_save() {
      var company = { ...this.company };
      company.fullname = company.fullname || null;
      company.address_street = company.address_street || null;
      company.address_street_no = company.address_street_no || null;
      company.address_zip = company.address_zip || null;
      company.address_city = company.address_city || null;
      company.address_country = company.address_country || null;
      company.responsible_name = company.responsible_name || null;
      company.responsible_role = company.responsible_role || null;
      company.updatedAt = undefined; // will be set by aws appsync
      company.createdAt = undefined; // will be set by aws appsync
      return company;
    },
  },
  mounted() {
    this.initRoute();
    this.$store.dispatch("getCompanies");
  },
  methods: {
    init() {
      return this.load();
    },
    load() {
      this.loading = true;
      this.$Amplify.API.graphql(this.getCompanyQuery).then((response) => this.onLoaded(response));
    },
    onLoaded(response) {
      this.company = response.data.getCompany;
      this.$store.commit("SET_active_company", { company: this.company });
      this.loading = false;
    },
    can_update_company() {
      var product_id = this.user_info.attributes["custom:active_product_id"];
      var product = products[product_id];
      var num_companies = this.$store.state.copyProcesses.companies.length;
      return num_companies <= product.usage.max_companies;
    },
    saveChanges() {
      this.save();
    },
    save() {
      if (this.can_update_company()) {
        this.$eventHub.emit("sync-status-syncing");
        this.company.processes = undefined;
        this.$Amplify.API.graphql(this.updateCompanyMutation)
          .then((response) => this.onSaved(response))
          .catch((error) => {
            this.$eventHub.emit("sync-status-failure", {
              entity_type: "Unternehmen",
              entity_label: this.company.name,
              sync_type: "update",
              error: error.errors[0].message,
            });
          });
      } else {
        this.show_company_update_disallowed = true;
      }
    },
    onSaved(response) {
      this.company.updatedAt = response.data.updateCompany.updatedAt;
      this.$eventHub.emit("sync-status-success", {
        entity_type: "Unternehmen",
        entity_label: this.company.name,
        sync_type: "update",
      });
      this.$eventHub.emit("company-updated");
      this.did_change = false;
      this.showCompanyEditDialog = false;

    },
    initRoute() {
      this.company = { id: this.$route.params.id };
      this.$eventHub.emit("sync-status-neutral");
      this.load();
    },
    discard() {
      this.showCompanyEditDialog = false;
    },
  },
  data: () => ({
    company: null,
    loading: true,
    errors: [],
    shortNameRules: [
      (v) => !!v || "Name des Unternehmens darf nicht leer sein",
      (v) => (v && v.length <= 140) || "Name des Unternehmens darf nicht mehr als 140 Zeichen haben",
    ],
    nameRules: [(v) => !v || v.length <= 140 || "Voller Name des Unternehmens darf nicht mehr als 140 Zeichen haben"],
    showCompanyEditDialog: false,
    _did_change: false,
    _save_timer: null,
    show_company_update_disallowed: false,
  }),
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped></style>
